import { render, staticRenderFns } from "./EditUserSettings.vue?vue&type=template&id=5c2db0a2&scoped=true&"
import script from "./EditUserSettings.vue?vue&type=script&lang=ts&"
export * from "./EditUserSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2db0a2",
  null
  
)

export default component.exports